/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

export const deleteProductType = createAsyncThunk(
  'productTypes/delete',
  async ({ productTypeId, title }, {
    extra: {
      sdk, localization, Logger, showDialogAsync,
    },
  }) => {
    const {
      TITLE, TEXT, OK, CANCEL,
    } = localization.DIALOGS.PRODUCT_TYPE_DELETE;

    try {
      const { promise } = showDialogAsync({
        title: TITLE(title),
        text: TEXT(),
        textBtnCancel: CANCEL,
        textBtnOk: OK,
      });
      await promise;
    } catch (error) {
      /** user pressed "Cancel" */
      return { cancelled: true };
    }

    try {
      await sdk.productTypes.delete(productTypeId);
      return { productTypeId };
    } catch (error) {
      Logger.error(new Error('Can not delete product type'), { error }, [
        'DeleteProductTypeFailed',
        { errorMessage: (error && error.message) || 'NoMessage' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder
    .addCase(deleteProductType.pending, (state, { meta }) => {
      const { productTypeId } = meta.arg;
      if (!state.processingIds.includes(productTypeId)) {
        state.processingIds.push(productTypeId);
      }
    })
    .addCase(deleteProductType.fulfilled, (state, { payload, meta }) => {
      state.processingIds = state.processingIds.filter(
        (processingId) => processingId !== meta.arg.productTypeId,
      );
      if (payload.cancelled) return;
      state.items = state.items.filter(({ _id }) => _id !== payload.productTypeId);
    })
    .addCase(deleteProductType.rejected, (state, { error, meta }) => {
      state.processingIds = state.processingIds.filter(
        (processingId) => processingId !== meta.arg.productTypeId,
      );
      state.error = error;
    });
};
